import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import InternalTools from "./routes/InternalTools";
import TemplateEditor from "./routes/TemplateEditor";
import OrganizationManagement from "./routes/OrganizationManagement";
import OrganizationManagementRoot from "./routes/OrganizationManagementRoot";
import OrganizationApproval from "./routes/OrganizationApproval";
import UserFeed from "./routes/User";
import UserApproval from "./routes/UserApproval";
import ProgressReportTemplateEditor from "./routes/ProgressReportTemplateEditor";
import OrganizationV2 from "./routes/OrganizationV2";
import StandardV2 from "./routes/StandardV2";
import Configurations from "./routes/Configurations";
import AccessManager from "./routes/AccessManager";
export default store => ({
  path: ":regionId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "administrator-tooling" */ "./components"),
        import(
          /* webpackChunkName: "administrator-tooling" */ "Tooling/modules/ToolingModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "tooling",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    TemplateEditor(store),
    InternalTools(store),
    ProgressReportTemplateEditor(store),
    UserApproval(store),
    UserFeed(store),
    OrganizationManagement(store),
    OrganizationApproval(store),
    OrganizationManagementRoot(store),
    OrganizationV2(store),
    StandardV2(store),
    Configurations(store),
    AccessManager(store),
  ],
});
